module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/error-no-results-baf9729be5c87d613e918367724babb5.svg";